import type { RecordMerchant } from 'features/table-columns/cells'
import { AddressesParams, constructorAddresses } from 'models/Addresses'
import {
  CustomerFieldsParams,
  constructorCustomerFields
} from 'models/ExtraFields'
import { Group, GroupParams, constructorGroup } from 'models/Overview/Group'

export interface CustomerParams {
  status?: string | null
  name?: string | null
  nickname?: string | null
  document?: string | null
  email?: string | null
  phone?: string | null
  createdAt?: string | null
  updatedAt?: string | null
  uuid?: string | null
  merchantUuid?: string | null
  address?: AddressesParams | null
  logo?: string
  customerGroups?: Group[]
  category?: string
  source?: string
  customerFields?: CustomerFieldsParams[]
  // SC-10999: só nas respostas agregadas (visão multi-empresas)
  merchant?: RecordMerchant | null
}

export function constructorCustomer(data: any) {
  const customer: CustomerParams = {
    address: data?.address
      ? constructorAddresses(data.address)
      : data?.addresses?.[0]
      ? constructorAddresses(data.addresses[0])
      : null,
    customerFields: data?.customer_fields
      ? constructorCustomerFields(data?.customer_fields)
      : [],
    createdAt: data?.created_at,
    document: data?.document,
    email: data?.email,
    merchantUuid: data?.merchant_uuid ? data?.merchant_uuid : null,
    name: data?.name,
    nickname: data?.nickname,
    phone: data?.phone,
    status: data?.status,
    updatedAt: data?.updated_at,
    uuid: data?.uuid,
    category: data?.category,
    source: data?.source,
    merchant: data?.merchant ?? null,
    logo: data?.logo_url ? data?.logo_url : '',
    customerGroups: data?.customer_groups
      ? data?.customer_groups?.map((item: GroupParams) =>
          constructorGroup(item)
        )
      : []
  }

  return customer
}
